/* SET STATE */
export const SET_STATE_LABREQUESTQUOTE = "SET_STATE_LABREQUESTQUOTE"

/* LABREQUESTQUOTES */
export const GET_LABREQUESTQUOTES = "GET_LABREQUESTQUOTES"
export const GET_LABREQUESTQUOTES_SUCCESS = "GET_LABREQUESTQUOTES_SUCCESS"
export const GET_LABREQUESTQUOTES_FAIL = "GET_LABREQUESTQUOTES_FAIL"

/* LABREQUESTQUOTE */
export const GET_LABREQUESTQUOTE = "GET_LABREQUESTQUOTE"
export const GET_LABREQUESTQUOTE_SUCCESS = "GET_LABREQUESTQUOTE_SUCCESS"
export const GET_LABREQUESTQUOTE_FAIL = "GET_LABREQUESTQUOTE_FAIL"

/**
 * ADD LABREQUESTQUOTE
 */
 export const ADD_NEW_LABREQUESTQUOTE = "ADD_NEW_LABREQUESTQUOTE"
 export const ADD_LABREQUESTQUOTE_SUCCESS = "ADD_LABREQUESTQUOTE_SUCCESS"
 export const ADD_LABREQUESTQUOTE_FAIL = "ADD_LABREQUESTQUOTE_FAIL"

 /**
 * UPDATE LABREQUESTQUOTE
 */
export const UPDATE_LABREQUESTQUOTE = "UPDATE_LABREQUESTQUOTE"
export const UPDATE_LABREQUESTQUOTE_STATUS = "UPDATE_LABREQUESTQUOTE_STATUS"
export const UPDATE_LABREQUESTQUOTE_SUCCESS = "UPDATE_LABREQUESTQUOTE_SUCCESS"
export const UPDATE_LABREQUESTQUOTE_FAIL = "UPDATE_LABREQUESTQUOTE_FAIL"

/**
 * DELETE LABREQUESTQUOTE
 */
export const DELETE_LABREQUESTQUOTE = "DELETE_LABREQUESTQUOTE"
export const DELETE_LABREQUESTQUOTE_SUCCESS = "DELETE_LABREQUESTQUOTE_SUCCESS"
export const DELETE_LABREQUESTQUOTE_FAIL = "DELETE_LABREQUESTQUOTE_FAIL"
